import Filters from '@/filters';

export function useCardDetailFormatter() {
    const formatBonusOfferDisplay = ({ bonus_units, bonus_amount, type }) => {
        if (!bonus_amount) return 'N/A';
        const amount = Filters.formatThousand(bonus_amount);
        const units = bonus_units || '';

        if (units === 'dollars' || units === 'statement_credits' || units === 'cashback') {
            return `$${amount}`;
        } else if (units === 'free_night') {
            return `${amount} free night${bonus_amount !== 1 ? 's' : ''}`;
        } else if (units === 'points' || units === 'miles') {
            return `${amount} ${Filters.ucWords(units)}`;
        } else if (units === 'other' && type) {
            return `${amount} ${Filters.ucWords(type)}`;
        }
        return `${amount}`;
    };

    const formatCardDetails = (val, dataType) => {
        if (dataType === 'received' && val === null) return 'No';
        if (typeof val === 'boolean') return val ? 'Yes' : 'No';

        if (
            dataType === 'credit_limit' ||
            dataType === 'annual_fee' ||
            dataType === 'minimum_spend_amount' ||
            dataType === 'product_changed_min_spend'
        ) {
            if (val === 0) return '$0';
            if (val === undefined || val === null) return 'N/A';
            return `$${Filters.formatThousand(Filters.formatMoney(val).replace('$', ''))}`;
        }

        if (
            (dataType === 'bonus_amount' || dataType === 'product_changed_bonus_amount') &&
            val != null
        ) {
            if (val === 0) return '0';
            return `${Filters.formatThousand(val)}`;
        }

        if (typeof val === 'string' && (dataType.includes('deadline') || dataType.includes('date'))) {
            if (!val) return 'N/A';
            return new Date(val).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
            });
        }

        if (typeof val === 'string') return Filters.ucWords(val);

        if (val instanceof Date) {
            return val.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
            });
        }

        if (val === undefined || val === null) return 'N/A';
        return val;
    };

    return {
        formatBonusOfferDisplay,
        formatCardDetails,
    };
}
